/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [text-utils.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 24.11.19, 13:06
 */

import he from '../../../node_modules/he/he';
import React from 'react';
import ReactDOMServer from 'react-dom/server';

// parse external url
const webRegex = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/igm;

// potentially dangerous code since used to render data in the public static folder
export const Unsafe_TextArrayAsHTML = ({text, ...otherProps}) => {
    return text.map((entry, index) => <Unsafe_TextAsHTML key={index} {...otherProps}>{entry}</Unsafe_TextAsHTML>)
};

// potentially dangerous code since used to render data in the public static folder. Disables dangerous html code
// before rendering s. "he" documentation for more infos
export const Unsafe_TextAsHTML = (props) => {
    return <p {...props} ref={ref => {if(ref) ref.innerHTML = he.decode(props.children);}}>
        {props.children}
    </p>
};

export const animateElement = (elem) => {
    elem.classList.remove("animate-headshake");
    void elem.offsetWidth;
    elem.classList.add("animate-headshake");
};

/* returns static html - web as list of strings, comma or newline separated */
export const asStaticExternalUrlList = (web) => {
    if(!web) return '';
    const urlList =  web.split(/,|\r|\n/).map((entry, index) => {
        const matches = webRegex.exec(entry.trim());
        const domain = matches && matches.length > 0 ? matches[0] : entry.trim();

        return <li key={index}>
            <a href={entry.trim()} target='_blank'><i className="fas fa-external-link-alt mr-1"/>{domain}</a>
        </li>;
    });

    return ReactDOMServer.renderToStaticMarkup(<ul className="external-url-list">{urlList}</ul>);
};

// resolve className dynamically
// usage cn('base-class', [true, 'some-class'], ['default-class'])
export function cn(...args) {
    let resolvedClass = '';
    args.forEach(arg => {
        if (Array.isArray(arg)) {
            if (arg[0]) {
                resolvedClass = resolvedClass + ' ' + (arg[1] ? arg[1] : arg[0]);
            }
        } else {
            resolvedClass = resolvedClass + ' ' + arg;
        }
    })
    return resolvedClass;
}
